import { AlertMessage, Theme, useTranslation, IconStyle } from '@nextgen-web-framework/all';
import { SpecialOfferAlertMessageProps } from './types/propTypes';
import styles from './SpecialOfferAlertMessage.module.scss';

const SpecialOfferAlertMessage = ({
  openOffersDrawer,
  selectedQuantity,
  totalSelectableQty,
}: SpecialOfferAlertMessageProps) => {
  const isSelected = selectedQuantity > 0;
  const t = useTranslation();

  const handleTextlinkClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    openOffersDrawer();
  };

  return (
    <div className={styles['special-offer-alert-container']}>
      <AlertMessage
        className={styles['special-offer-alert']}
        theme={isSelected ? Theme.SUCCESS : Theme.ACTION}
        iconColor={isSelected ? Theme.SUCCESS : Theme.PURPLE}
        textLink={{
          text: t(`promotion.specialOffer.${isSelected ? 'changeButton' : 'selectButton'}`),
          onClick: handleTextlinkClick,
        }}
        icon="tags"
        iconStyle={IconStyle.SOLID}
      >
        <div className={styles['alert-content']}>
          <span className={styles['alert-title']}>{t('promotion.specialOffer.alertHeading')}</span>
          <span className={`${styles['alert-detail']} ${isSelected && styles['theme-black']}`}>
            {`(${selectedQuantity}/${totalSelectableQty} ${t('promotion.specialOffer.alertProductsSelected')})`}
          </span>
        </div>
      </AlertMessage>
    </div>
  );
};

export default SpecialOfferAlertMessage;
